module.exports = __webpack_public_path__ + "img/home-hero-image_medium.b076cb3a.webp";